<template>
  <f7-page class="homepage" name="index">
    <bc-navbar></bc-navbar>
    <div class="homepage-content">
      <home-page-slider :slides="homeSlides" />
      <bottom-panel :referralsCount="historyLoaded ? referralsCount : null" />
    </div>
  </f7-page>
</template>

<script>
/* eslint-disable */
import { mapState, mapGetters } from "vuex";
import HomePageSlider from '@/components/home-page-components/home-page-slider.component'
import BottomPanelMenu from '@/components/home-page-components/bottom-panel-menu.component'
import { referralsCounterHelper } from '@/helpers/referral-history.helper'
export default {
  name: 'home-page',
  components: {
    'bottom-panel': BottomPanelMenu,
    'home-page-slider': HomePageSlider
  },
  computed: {
    ...mapState({
      isAddToHSShowedFlag: state => state.standalone.isAddToHShowed,
      customization: state => state.common.customization,
      homeSlides: (state) => state.common.homeImages,
      referralsCount: (state) => referralsCounterHelper(state.recommendFriend.historyCount)
    }),
    ...mapGetters({
      historyLoaded: 'recommendFriend/historyLoaded'
    })
  }
}
</script>
<style scoped>
.homepage-content {
  height: 100%;
  display: grid;
  grid-template-rows: 1fr auto;
  align-items: start;
}
</style>
<style lang="scss">
@import "~styles/_variables.scss";

#main-view.navbar-fixed .page-content {
  padding-top: $bc-navbar-height;
}
</style>


// WEBPACK FOOTER //
// index.page.vue?f4962c9c